export default (state, action) => {
	switch (action.type) {
		default:
			return null;
    }
    return null;
}